import { NgModule } from '@angular/core'
import { OldSearchModule } from '../libs/_deprecated/search/old-search.module'
import { SearchComponent } from './search.component'
import { SearchRoutingModule } from './search-routing.module'
import { CommonModule } from '@angular/common'
import { ContentRightRailLayoutModule } from '../libs/_layouts/content-right-rail-layout/content-right-rail-layout.module'
import { ErrorModule } from '../libs/error/error.module'
import { IfLoadedModule } from '../shared/directives/if-loaded/if-loaded.module'

@NgModule({
  imports: [
    CommonModule,
    SearchRoutingModule,
    OldSearchModule,
    ContentRightRailLayoutModule,
    ErrorModule,
    IfLoadedModule
  ],
  declarations: [SearchComponent]
})
export class SearchModule {}
